export default "__VITE_ASSET__95277f95__"